import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const ControlFeedbackContext = createContext(null);

export function ControlFeedbackProvider({ children }) {
  const [feedbackItems, setFeedbackItems] = useState([]);

  const showFeedback = useCallback((data, options = {}) => {
    const id = options.id ?? crypto.randomUUID();

    setFeedbackItems((currentItems) => [
      ...currentItems,
      {
        id,
        data,
        autoCloseMs: options.autoCloseMs ?? 5000
      }
    ]);

    return id;
  }, []);

  const removeFeedback = useCallback((id) => {
    setFeedbackItems((currentItems) => currentItems.filter((item) => item.id !== id));
  }, []);

  const clearFeedback = useCallback(() => {
    setFeedbackItems([]);
  }, []);

  const value = useMemo(
    () => ({
      feedbackItems,
      showFeedback,
      removeFeedback,
      clearFeedback
    }),
    [feedbackItems, showFeedback, removeFeedback, clearFeedback]
  );

  return <ControlFeedbackContext.Provider value={value}>{children}</ControlFeedbackContext.Provider>;
}

export function useControlFeedback() {
  const context = useContext(ControlFeedbackContext);

  if (!context) {
    throw new Error('useControlFeedback must be used inside ControlFeedbackProvider');
  }

  return context;
}
